import { Router,RouterLink} from "@angular/router";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { SessionService } from "../../../../@core/session/session.service";
import { Store } from "../../../../@core/store/store";
import { AppLocalStorage } from "../../../../@core/utils/local-storage.util";
import { IntranetService } from "../service/intranet.service";
import { ApprovalDetailsV2Component } from "./approval-details-v2/approval-details-v2.component";
import { RequestConfirmationV2Component } from "./request-confirmation-v2/request-confirmation-v2.component";
import { NbDialogService } from '@nebular/theme';
import { HeaderService } from "../../../../@theme/components/header/service/header.service";
import { RequestsForApprovalsLoadedState, RequestsForApprovalsLoadingErrorState, RequestsForApprovalsLoadingState, MyRequestLoadedState,MyRequestLoadingErrorState, MyRequestLoadingState } from "../../../../@theme/components/header/service/header.state";
import { DynamicStackService } from "../../dynamic-stack/service/dynamic-stack.service";
import { RemindersLoadedState, RemindersLoadingErrorState, RemindersLoadingState } from "../../dynamic-stack/service/dynamic-stack.state";
import { environment } from "../../../../../environments/environment";
import { UserTrackingService } from "../../../../@core/utils";

@Component({
  selector: 'ltts-request-for-approvals-v2',
  templateUrl: './request-for-approvals-v2.component.html',
  styleUrls: ['./request-for-approvals-v2.component.scss']
})
export class RequestForApprovalsV2Component implements OnInit{
@ViewChild(ApprovalDetailsV2Component)
  approvalDetailsComponent: ApprovalDetailsV2Component;

  @Output() fetchRequest = new EventEmitter<any>();
  @Output() fetchAttendanceRequest = new EventEmitter<any>();
  @Output() fetchCarRequest = new EventEmitter<any>();
  @Output() fetchLeaveRequest = new EventEmitter<any>();
  @Output() fetchAccommodationRequest = new EventEmitter<any>();
  @Output() fetchSynergyRequest = new EventEmitter<any>();
  @Output() collapseSidenavEvent = new EventEmitter<void>();
  @Output() navigateToUrlEvent = new EventEmitter<string>();
  showForex: boolean = false;
   // Notify section inputs
  @Input() hasActiveISMS: any;
  @Input() hasActiveDataPrivacy: any;
  @Input() completedCount: number = 0;
  @Input() notifications: any[] = [];
  @Input() hasActiveQuiz: boolean = false;
  @Input() showQuizNotify: boolean = true;
  @Input() hasActiveTownhall: boolean = false;
  @Input() showTownhallNotify: boolean = true;
  @Input() appraisalData: boolean | undefined 
  @Input() talentAIData: boolean | undefined 

  btnText: string = "View More";
  headerTitle: string = "Request for Approvals";
  reqForApprovalsData: any;
  myRequestData:any;
  reqForAttendanceApprovalsData: any;
  reqForLeaveApprovalData: any;
  reqForCarApprovalData: any;
  reqForAccommodationApprovalData: any;
  showDetailsCard: boolean;
  reqData: any;
  isRequestForApprovalsDataEmpty: boolean;
  userDataObj: any;
  emailID: any;
  employeeID: any;
  shimmerCard: number[] = [1, 2, 3, 4];
  requestsLoading: boolean;
  attendanceRequestLoading: boolean;
  leaveRequestLoading: boolean;
  carRequestLoading: boolean;
  accommodationRequestLoading: boolean;
  emptyDataForRequest: boolean = true;
  emptyAttendanceDataRequest: boolean = true;
  emptyLeaveDataRequest: boolean = true;
  emptyCarDataRequest: boolean = true;
  emptyAccommodationDataRequest: boolean = true;
  accountData: any ;
  selectedCategory: any;
  remindersData: any[] = [];
  remindersLoadingData: boolean = false;
  forexData: any[] = [];
  forexLoadingData: boolean = false;
  synergyApprovals: any;
  synergyLoadingData: boolean = false;
  isSynergyApprover: boolean = false;
  expandedAccordionCount: number = 0;
  
  //  tooltipText: string[] = ['Accommodation', 'Attendance', 'Cab', 'Leave', 'Synergy'];
  tooltipText: string = `Accommodation\nAttendance\nCab\nLeave\nSynergy`;
  cmsbase_url: any;
  EmptyState: string;




  constructor(
    private intranetService: IntranetService,
    private sessionService: SessionService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private dialogService: NbDialogService,
    private headerService: HeaderService,
    private dynamicStackService: DynamicStackService,
    private userTrackingService: UserTrackingService
  ) {
  }

  @Input()
  set approvalData(value) {
    if (value) {
      this.reqForApprovalsData = value;
      this.emptyDataForRequest = this.reqForApprovalsData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set attendanceApprovalData(value) {
    if (value) {
      this.reqForAttendanceApprovalsData = value;
      this.emptyAttendanceDataRequest = this.reqForAttendanceApprovalsData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set leaveApprovalData(value) {
    if (value) {
      this.reqForLeaveApprovalData = value;
      this.emptyLeaveDataRequest = this.reqForLeaveApprovalData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set carApprovalData(value) {
    if (value) {
      this.reqForCarApprovalData = value;
      this.emptyCarDataRequest = this.reqForCarApprovalData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set accommodationApprovalData(value) {
    if (value) {
      this.reqForAccommodationApprovalData = value;
      this.emptyAccommodationDataRequest = this.reqForAccommodationApprovalData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set reminders(value) {
    if (value) {
      this.remindersData = value;
      this.cdRef.detectChanges();
    }
  }

   @Input()
  set forexReqForApprovalsData(value) {
    if (value) {
      this.forexData = value;
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set synergyApprovalData(value) {
    if (value) {
      const updatedSynergyApprovalData = {
        ...value, tickets: value.tickets?.map(ticket => ({
          ...ticket,
          categoryName: 'Synergy' // Replace with your logic or value
        }))
      };
      this.synergyApprovals = [updatedSynergyApprovalData];
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set loadingData(value) {
    // if(value){
    this.requestsLoading = value;
    this.cdRef.detectChanges();
    // }
  }

  @Input()
  set attendanceLoadingData(value) {
    this.attendanceRequestLoading = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set leaveLoadingData(value) {
    this.leaveRequestLoading = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set carLoadingData(value) {
    this.carRequestLoading = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set accommodationLoadingData(value) {
    this.accommodationRequestLoading = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set remindersLoading(value) {
    this.remindersLoadingData = value;
    this.cdRef.detectChanges();
  }
   @Input()
  set forexRequestsDataLoading(value) {
    this.forexLoadingData = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set synergyLoading(value) {
    this.synergyLoadingData = value;
    this.cdRef.detectChanges();
  }


  // @Output() fetchRequest = new EventEmitter();

  ngOnInit(): void {
    //this.showForex  = Boolean(environment.showForex);
    this.accountData=AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA");
    this.showForex  = window['env']?.showForex == 'true'
    const me = this;
    const loginEmail = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA");
    const profileData =  AppLocalStorage.get("PROFILE_DATA", "PROFILE_DATA");
    this.isSynergyApprover = Boolean(profileData?.isSynergyApprover);
    this.emailID = loginEmail.profile.email;

    this.employeeID = loginEmail.profile.employeeId;

    me.sessionService.userConfigData$.subscribe((data) => {
      if (data) {
        // const emailId = data?.profile?.email;
        const employeeId=data?.profile?.employeeId;
        // me.fetchRequestForApprovalsData(emailId);
        me.fetchMyRequestData(employeeId)
      }
    });
    //me.getRemindersListData(this.employeeID);
    this.cmsbase_url = environment.CMSURL_IMG;
    this.EmptyState = this.cmsbase_url+"wp-content/uploads/2025/05/EmptyState.png";
  }

  get containerHeightStyle() {
    // Check if there's any content to display
    const hasContent = 
      (!this.emptyAttendanceDataRequest && !this.attendanceRequestLoading) ||
      (!this.emptyLeaveDataRequest && !this.leaveRequestLoading) ||
      (!this.emptyCarDataRequest && !this.carRequestLoading) ||
      (!this.emptyAccommodationDataRequest && !this.accommodationRequestLoading) ||
      (this.remindersData && this.remindersData.length > 0) ||
      (this.synergyApprovals && this.synergyApprovals.length > 0) ||
      (this.showForex && this.forexData && this.forexData.length > 0);

    // If any accordion is expanded (count > 0), use auto height to allow expansion
    // If no accordions are expanded (count = 0), maintain 100% height
    return { 'height': this.expandedAccordionCount > 0 ? 'auto' : '100%' };
  }

  onAccordionStateChange(isExpanded: boolean) {
    // Increment count when accordion opens, decrement when it closes
    if (isExpanded) {
      this.expandedAccordionCount++;
    } else {
      this.expandedAccordionCount = Math.max(0, this.expandedAccordionCount - 1);
    }
    this.cdRef.detectChanges();
  }

  isSameValueForKey(arr: any[], key: string): boolean {
    if (arr.length === 0) return true; // Return true if the array is empty

    const firstValue = arr[0][key]; // Get the value of the key in the first object
    return arr.every((obj) => obj[key] === firstValue);
  }

  fetchRequestForApprovalsData(emailId: string) {
    const me = this;
   
    me.headerService.fetchRequestsForApprovals(emailId).subscribe(
      (state: Store.State) => {
        if (state instanceof RequestsForApprovalsLoadingState) {
          return;
        }
        if (state instanceof RequestsForApprovalsLoadedState) {
          // this.requestsLoading = false;
          me.reqForApprovalsData = state.data.data;
          this.cdRef.detectChanges();
          return;
        }
      },
      (state: RequestsForApprovalsLoadingErrorState) => {
        me.isRequestForApprovalsDataEmpty = true;
        this.requestsLoading = false;
        return;
      }
    );
  }

  fetchMyRequestData(employeeId:string){
     const me = this;
   
    me.headerService.fetchMyRequestsData(employeeId).subscribe(
      (state: Store.State) => {
        if (state instanceof MyRequestLoadingState) {
          return;
        }
        if (state instanceof MyRequestLoadedState) {
          // this.requestsLoading = false;
          me.myRequestData = state.data.data;
          this.cdRef.detectChanges();
          return;
        }
      },
      (state: MyRequestLoadingErrorState) => {
        me.isRequestForApprovalsDataEmpty = true;
        this.requestsLoading = false;
        return;
      }
    );

  }
  fetchAttendanceRequestForApprovalData() {
    this.fetchAttendanceRequest.emit()
  }

  fetchCarRequestForApprovalData() {
    this.fetchCarRequest.emit()
  }

  fetchLeaveRequestForApprovalData() {
    this.fetchLeaveRequest.emit()
  }

  fetchAccommodationRequestForApprovalData() {
    this.fetchAccommodationRequest.emit()
  }

  fetchSynergyRequestForApprovalData() {
    this.fetchSynergyRequest.emit()
  }



  approveAll(event) {
    const reqBody = {
      category: event.categoryName,
      userId: this.employeeID,
      ticketID: "",
      employeeId: 0,
      fromDate: "",
      toDate: "",
    };

    this.dialogService.open(RequestConfirmationV2Component, {
      context: {
        title: 'Are you sure you want to approve all requests?',
        reqData: reqBody,
        action: 'approveAll'
      },
    }).onClose.subscribe((value) => {
      if (value) {
        this.fetchRequest.emit();
        // this.fetchRequestForApprovalsData(this.emailID);
      }
    });


  }

  approveRequest(selectedCategory) {
    const me = this;
    this.selectedCategory = selectedCategory;
    this.fetchRequest.emit();
    // this.fetchRequestForApprovalsData(this.emailID);
    return;

  }



  declineRequest(selectedCategory) {
    this.selectedCategory = selectedCategory;
    this.fetchRequest.emit();
    // this.fetchRequestForApprovalsData(this.emailID);
    return;

  }

  onClickRequest(data) {
    const me = this;
    if (data) {
      const reqData = data;
      reqData["loggedInUser"] = me.userDataObj?.employeeName;
      me.reqData = reqData;
      me.showDetailsCard = true;
    }
  }

  handleChildEvent(event) {
    const me = this;
    me.showDetailsCard = !event;
  }

  viewMore() {
    this.router.navigateByUrl("my-team/" + btoa(this.employeeID));
  }
  onTabChange(event: any) {
  this.userTrackingService.track('Notification_Clicked', {'value':event.tabTitle}, "Header");
  }
  // Notify section event handlers
  cancelClicked() {
    this.collapseSidenavEvent.emit();
  }

  navigateToUrl(url: string) {
    this.navigateToUrlEvent.emit(url);
  }


}
